function GetSizeOfColor(params) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetSizeOfColors" + getLandingParameter(),
        data: params,
        success: function (data) {

            $basketButton.parents(".AddToCartArea").find(".ProductListSizeContainer").html(data);
            var $firstSize = $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize.active:first");

            var firstSizeId = ($firstSize.length > 0 ? $firstSize.attr("data-size") : 0);

            $basketButton.removeClass("passive");

            if (firstSizeId === 0) {
                $basketButton.addClass("passive");

                //if ($("#SmallLangCode").val() === "tr") {
                //    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding soldOutBadge' style='z-index:1'><img src='/images/"+companyThemePath+"/badge/tukendi.png'></div>");

                //}
                //else if ($("#SmallLangCode").val() === "en") {
                //    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding soldOutBadge'><img src='/images/"+companyThemePath+"/badge/sold_out.png'></div>");
                //}
                //else if ($("#SmallLangCode").val() === "fr") {
                //    $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding soldOutBadge'><img src='/images/"+companyThemePath+"/badge/epuise.png'></div>");
                //}
            }

            $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize").removeClass("active");
            $basketButton.parents(".AddToCartArea").children(".TransformContainer").addClass("select-size");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });
}

function GetImageOfColors(params, item_unique_id, currentColor) {
    var companyThemePath = "DUB";
    var lazyImage = "/Images/" + companyThemePath+"/lazy_back_new.jpg";
    Prd = $("#Prd" + item_unique_id);
    //Prd.addClass("loading");
    GenerateLocalLoading(Prd, "show");

    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetImageOfColors" + getLandingParameter(),
        data: params,
        success: function (data) {
            $Crs = $("#Crs_" + item_unique_id);
            $Crs.html("");

            var urlNew = "";

            if (data.ProductUrl != undefined && data.ColorUrl != undefined) {
                urlNew += getRequestRoute() + "/" + data.ColorUrl + "-" + data.ProductUrl + "-" + data.ColorID;
            }

            if (data.ImgPath1 != null) {
                var imgKucuk1 = $('<a href="' + urlNew + '" ><img class="img1 PImage img-responsive" src="' + data.ImgPath1 + '"></a>');

                imgKucuk1.appendTo($Crs);
            }

            //AddToCart attributeleri değiştir
            currentColor.closest(".Prd").find(".QuickShop").attr("data-colorid", data.ColorID);
            currentColor.closest(".Prd").find(".QuickShop").attr("data-productid", data.ProductID);

            //sistemde tanımlı badgeler varsa eklenmeli.
            if (data.BadgeImagePath != null && data.BadgeImagePath != undefined && data.BadgeTur != 14) {
                currentColor.closest(".Prd").find(".ProductBadge").html("");

                if (data.BadgeTur == 7) {
                    currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                } else if (data.BadgeTur == 8) {
                    currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                } else if (data.BadgeTur == 9) {
                    currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                } else if (data.BadgeTur == 10) {
                    currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                }
            }
            
            GenerateLocalLoading(Prd, "hide");
        },
        error: function (xhr, status, error) {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading(Prd, "hide");
        }
    });
}

function IsfollowForProductDetails() {

    var ProductID = $("#PID").val();
    var AName = $("#AName").val();
    var CName = $("#CName").val();

    $That = $(".AddToFavorite");

    if (ProductID != undefined && ProductID != null && ProductID != "" && ProductID > 0 && AName == "Index" && CName == "ProductDetails") {
        $.ajax({
            type: 'get',
            url: getRequestRoute() + "/p/ProductDetails/IsFollow" + getLandingParameter(),
            data: 'ProductID=' + ProductID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.IsFollow == true) {
                    $That.removeClass("passiveFavorite");
                    $That.addClass("activeFavorite");
                    $That.find(".sorsfont").removeClass("sorsfont-favorite").addClass("sorsfont-favorite-o");
                } else {
                    $That.addClass("passiveFavorite");
                    $That.removeClass("activeFavorite");
                }
            }
        });
    }
}

function GetProductInstalments(Amount) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetInstallmentOptions?Amount=" + Amount.replace(".", ""),
        success: function (data) {
            $(".InstallmentBody").html(data);
            $("#TaksitSecenekleri").modal();
            $('html, body').animate({
                scrollTop: $("#PdInstallmentOptionsDetail").offset().top - 50
            }, 500);
        }
    });
}

function GetProductWarn(data) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/StokWarn" + getLandingParameter(),
        data: data,
        success: function (data) {
            if (data != "0" && data != 0) {

                var prdCls = "More";

                $(".LastProducts").removeClass("One");
                $(".LastProducts").removeClass("Two");
                $(".LastProducts").removeClass("More");
                $(".LastProducts").removeClass("Limited");

                $(".LastX").html(data);
                $(".LastPrdHint").html($(".LastPrdHint").attr("data-more"));

                if (data.length > 1) {
                    $(".LastX").css("margin-left", "2px");
                }
                else {
                    $(".LastX").css("margin-left", "4px");
                }

                switch (data) {
                    case "1": prdCls = "One"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-one")); break;
                    case "2": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                    case "3": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                    case "": prdCls = "gizli"; $(".LastPrdHint").html(""); break;
                    case "4": prdCls = "Limited"; break;
                }

                $(".LastProducts").addClass(prdCls);
                $(".LastProducts").show();
            }
        }
    });
}

function ChangeProductColor(ProductID, ColorID, LangID, callback) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/getProductDetailAjax" + getLandingParameter(),
        data: "ProductID=" + ProductID + "&ColorID=" + ColorID + "&LangID=" + LangID,
        async: true,
        cache: false,
        beforeSend: function () {
            GenerateLocalLoading($("#NewPd"), "show");
        },
        success: function (data) {
            alert("test");
            callback(data, true);
        },
        error: function () {
            callback("", false);
        },
        complete: function () {
            GenerateLocalLoading($("#NewPd"), "hide");
        }
    });
}

//function ChangeColorGetSize(colorID, productID) {
//    var params = "ColorID=" + colorID + "&ProductID=" + productID;
//    var c = 0;
//    var img = "";
//    var companyThemePath = "DUB"


//    $.ajax({
//        type: "GET",
//        url: getRequestRoute() + "/p/ProductDetails/GetAllDetailInfoByColorID"+ getLandingParameter(),
//        data: params,
//        success: function (data) {
//            console.log(data);

//            $selectSizePopup = $(".SizeOptions #SelectSizePopup");

//            if ($selectSizePopup.length > 0) {
//                $selectSizePopup = $(".SizeOptions #SelectSizePopup").clone();
//            }

//            $(".SizeOptions").html("");
//            if ($selectSizePopup.length > 0) {
//                $(".SizeOptions").append($selectSizePopup);
//            }

//            // GetNewColorImage
//            var fotoSayisi = $(".ProductDetailImages ul li.ImgArea").length;

//            if (isMobileResolution()) {
//                $(".ProductDetailsMainImage > ul").slick('unslick');
//                $(".ProductDetailsMainImage > ul li").remove();
//            }
//            else {
//                $(".ProductDetailsMainImage > ul > li").remove();
//            }

//            //if (!isMobileResolution()) {
//            //    $(".SmallProductImages > ul").slick('unslick');
//            //    $(".SmallProductImages > ul > li").remove();
//            //}

//            $.each(data.reverse(), function (k, v) {
//                if (v.Type == "StockImage") {
//                    c++;

//                    var selected = "";
//                    if (c == 1) {
//                        selected = " Selected ";
//                    }

//                    $(".ProductDetailsMainImage > ul").append('<li class="ImgArea fancybox ' + selected + '" href="' + v.Name.replace("_enbuyuk", "_buyuk") + '"><img src="' + v.Name.replace("_enbuyuk", "_buyuk") + '"  /></li>'); 

//                    //if (!isMobileResolution()) {
//                    //    $(".SmallProductImages > ul").append('<li><img src="' + v.Name.replace("_buyuk", "_kucuk") + '" class="' + selected + '"  /></li>'); 
//                    //}
//                }
//            });

//            if (isMobileResolution()) {
//                SlickSlider("main");
//            }

//            // GetNewColorSize
//            var newSizeCount = 0;
//            $(".SizeOptions").removeClass("passed");
//            $("#SizeID").val("");
//            $.each(data.reverse(), function (k, v) {
//                if (v.Type == "Size") {
//                    var stil = "";
//                    if (v.InStock == false || v.PStatus != 1) {
//                        stil = "OutOfQuantity";

//                        if ($(".NewPD").length > 0) {
//                            $(".SizeOptions").append('<span class="outer">' +
//                                ' <input type="hidden" name="SizeIDs" id="SizeIDs" value="' + v.ID + '" >' +
//                                ' <span class="PdHint"> <span class="PdHint-content">Bu Ürünün ' + v.Name + ' Bedeni Stoklarla Kalmamıştır.<br />' +
//                                '<a href="javascript:;" class="NotifyWhen">Ürün stoğa geldiğinde haber ver!</a>' +
//                                ' </span><i class="reactangle"></i></span>'
//                                + '<span class="inner">' + v.Name + '</span></span>');
//                        } else {
//                            $(".SizeOptions").append('<span class="outer"><span class="inner">' + v.Name + '</span></span>');
//                        }

//                        $('.AddToRemindList').show();
//                    }
//                    else {
//                        newSizeCount++;
//                        $(".SizeOptions").append('<span><a data-id="' + v.ID + '" data-stock="' + v.InStock + '" data-name="' + v.Name + '" href="javascript:void(0)" class="' + stil + " " + v.Name + '">' + v.Name + '</a></span>');
//                    }
//                }
//            });

//            if (newSizeCount == 0) {
//                var badgeArea = "<div class='PDIConItem'><img src='/Images/"+companyThemePath+"/badge/tukendi.png' alt='Bu ürün stoklarımızda tükenmiştir.'>";
//                badgeArea += '<div class="text-tooltip hidden-xs hidden-sm"><span class="reactangle"></span><span class="text">Bu ürün stoklarımızda tükenmiştir.</span></div ></div>';

//                $(".ProductContent .BadgeContainer").html(badgeArea);
//            }
//            else {
//                $(".ProductContent .BadgeContainer").html("");
//            }

//            // GetNewColorSize
//            if ($(".NewPD").length > 0) {
//                $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("open");

//                $(".Colors span.ChooseTitle").removeClass("current");
//                $(".Colors span.ChooseTitle").addClass("passed");

//                $(".SizeAndAmount span.ChooseTitle").addClass("current");
//                $(".SizeAndAmount span.ChooseTitle").removeClass("passed");

//                $(".AmountOptions span.ChooseTitle").removeClass("current");
//                $(".AmountOptions span.ChooseTitle").removeClass("passed");

//                $(".AmountOptions").removeClass("open");

//                $(".Sizes").find(".Name").html("");

//                $(".AddToBasket button").addClass("NotSelected");
//                $(".AddCombineToBasket button").addClass("NotSelected");

//                if ($(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0) {
//                    $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
//                }

//                if ($(".AddCombineToBasket button").attr("data-first") != undefined && $(".AddCombineToBasket button").attr("data-first").length > 0) {
//                    $(".AddCombineToBasket button").text($(".AddCombineToBasket button").attr("data-first"));
//                }
//            }

//            //if (isMobile(true)) {
//            //    $oldUl = $(".ProductDetailImages ul:first");
//            //    $newul.insertAfter($(".ProductDetailImages ul:first"));
//            //    $oldUl.remove();
//            //}

//            if ($(".SizeOptions .ONE.SIZE").length > 0) {
//                $(".SizeOptions .ONE.SIZE").trigger("click");
//                $(".SizeAndAmount").hide();
//            }
//            else {
//                $(".SizeAndAmount").show();
//            }
//        },
//        error: function () {
//            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
//        }
//    });

//}

function GetListForRemind(data) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetListForRemind" + getLandingParameter(),
        data: data,
        cache: true,
        success: function (data) {

            $("#PrdBlackBg").hide();
            $(".SizeOptions.open").removeClass("PleaseSelect");
            $(".DropItems.PleaseSelect").removeClass("PleaseSelect");
            $(".AddToBasketOuther.PleaseSelect").removeClass("PleaseSelect");
            $("#RemindMeLater").addClass("active");

            if ($(".AutoTextRep").length > 0) {
                $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
            }

            $("#NotifyModal").modal("show");
            $("#NotifyModal").css("display", "flex");

            $("#NotifyModal .modal-body").html(data);
            $(".NotifyColors a:first").trigger("click");

            if (data != null && data != "" && data != undefined) {
                if (data.length < 300) {
                    $("#NotifyModal .modal-footer button").hide();
                }
                else {
                    $("#NotifyModal .modal-footer button").show();
                }
            }
        }
    });
}

function RemindMeWhenAvailable(data) {
    $.ajax({
        type: "POST",
        url: getRequestRoute() + "/p/ProductDetails/RemindMeWhenAvailable" + getLandingParameter(),
        data: data,
        dataType: "json",
        beforeSend: function () {
            GenerateLocalLoading($("#NotifyModal"), "show");
        },
        success: function (dt) {
            if (dt.Sonuc == true) {
                $("#NotifyModal").modal("hide");
                SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        },
        complete: function () {
            GenerateLocalLoading($("#NotifyModal"), "hide");
        }
    });
}

function AddToFavorite(ColorID, ProductID, callback) {   
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddToFollowList" + getLandingParameter(),
        data: 'colorID=' + ColorID + "&productID=" + ProductID,
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                callback(true, "");
            }
            else {                
                callback(false, getStandartMessages("FavorilerIcinGirisYapin"));
            }
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function removeFavorite(ProductID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/RemoveFromList" + getLandingParameter(),
        data: 'id=' + ProductID + "&IsDetail=true",
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                callback(true);
            }
        },
        error: function () {
            callback(false);
        }
    });
}

function ChangeCombineSliderPhoto(data) {
    GenerateLocalLoading($(".ProductDetailImages"), "show");
    GenerateLocalLoading($(".SmallProductImages"), "show");

    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/ProductDetails/GetAllDetailInfoByColorID" + getLandingParameter(),
        data: data,
        success: function (data) {

            $(".ProductDetailImages > ul").slick('unslick');
            $(".ProductDetailImages > ul > li").remove();

            $(".SmallProductImages > ul").slick('unslick');
            $(".SmallProductImages > ul > li").remove();

            var c = 0;
            $.each(data.reverse(), function (k, v) {
                if (v.Type == "StockImage") {
                    c++;
                    var selected = "";
                    if (c == 1) {
                        selected = " Selected ";
                    }

                    $(".ProductDetailImages > ul").append('<li class="ImgArea fancybox ' + selected + '" href="' + v.Name.replace("_enbuyuk", "_buyuk") + '"><img src="' + v.Name.replace("_enbuyuk", "_buyuk") + '"  /></li>');

                    if ($(window).width() > 991) {
                        $(".SmallProductImages > ul").append('<li><img src="' + v.Name.replace("_buyuk", "_kucuk") + '" class="' + selected + '"  /></li>');
                    }
                }
            });

            SlickSlider(false);

            GenerateLocalLoading($(".ProductDetailImages"), "hide");
            GenerateLocalLoading($(".SmallProductImages"), "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            GenerateLocalLoading($(".ProductDetailImages"), "hide");
            GenerateLocalLoading($(".SmallProductImages"), "hide");
        }
    });
}

function GetLastVisitedData() {
    var LastVisitedPrds = [];
    var lastPrdsKey = "LastVisitedPrds-" + $("#SmallCountryCode").val() + "-" + $("#SmallLangCode").val();

    var LandingParam = getLandingParameter();

    if (LandingParam) {
        LandingParam = LandingParam.split('=')[1];

        lastPrdsKey += "-" + LandingParam;
    }

    LastVisitedPrds = localStorage.getItem(lastPrdsKey);

    if (LastVisitedPrds == undefined) {
        LastVisitedPrds = [];
    }
    else {
        LastVisitedPrds = JSON.parse(LastVisitedPrds);
    }

    return LastVisitedPrds;
}

function GetLastVisitedPrdView(productData, callback) {
    if ($(".AutoGetLastVisited").length > 0) {
        $.ajax({
            type: "POST",
            url: getRequestRoute() + "/p/ProductDetails/GetLastVisitedProductsView" + getLandingParameter(),
            data: JSON.stringify(productData),
            //contentType:"text/html",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {
                callback(dt);
            }
        });
    }
}

function GetPageAndFilter(params, callback) {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/Home/GetProductList" + getLandingParameter(),
        data: params,
        cache: false,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
            $(".ProductList").removeClass("NotFoundContainer");
            $(".ProductList .NotFound").remove();
            $(".ProductList .SuggestedProductsContainer").remove();
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (data) {
            callback(true, data);
        },
        error: function () {
            callback(false, "");
        }
    });
}

function AddToCard(param, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddToCart" + getLandingParameter(),
        data: param,
        dataType: 'json',
        async: true,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
            $(".ProductList").removeClass("NotFoundContainer");
            $(".ProductList .NotFound").remove();
            $(".ProductList .SuggestedProductsContainer").remove();
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            callback(dt);
        }
    });
}

function GetQuickShop(ProductID, ColorID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/ProductDetails/QuickLook" + getLandingParameter(),
        data: "ProductID=" + ProductID + "&ColorID=" + ColorID,
        async: true,
        beforeSend: function () {
            GenerateLocalLoading($("body"), "show");
        },
        complete: function () {
            GenerateLocalLoading($("body"), "hide");
        },
        success: function (dt) {
            callback(true, dt);
        },
        error: function () {
            callback(false, "");
        }
    });
}